import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Route } from "react-router-dom";
import PoliciesPageCommunity from "./PoliciesPageCommunity";
import PoliciesPageCopyright from "./PoliciesPageCopyright";
import PoliciesPageNav from "./PoliciesPageNav";
import PoliciesPagePrivacy from "./PoliciesPagePrivacy";
import PoliciesPageTerms from "./PoliciesPageTerms";
import PoliciesPageTrademark from "./PoliciesPageTrademark";
const PoliciesPage = ()=>{
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(PoliciesPageNav, {}),
            /*#__PURE__*/ _jsx(Route, {
                path: "/community",
                component: PoliciesPageCommunity
            }),
            /*#__PURE__*/ _jsx(Route, {
                path: "/copyright",
                component: PoliciesPageCopyright
            }),
            /*#__PURE__*/ _jsx(Route, {
                path: "/privacy",
                component: PoliciesPagePrivacy
            }),
            /*#__PURE__*/ _jsx(Route, {
                path: "/terms",
                component: PoliciesPageTerms
            }),
            /*#__PURE__*/ _jsx(Route, {
                path: "/trademark",
                component: PoliciesPageTrademark
            })
        ]
    });
};
export default PoliciesPage;
